import React, { FC } from "react";
import { Tag, Tooltip } from "antd";
import { DownloadOutlined, SignatureOutlined } from "@ant-design/icons";

interface TagSignProps {
  tag: string | undefined;
  onClickDownload: () => void;
  onClickSignInfo: () => void;
}

export const TagLeadSign: FC<TagSignProps> = ({
  tag,
  onClickDownload,
  onClickSignInfo,
}) => {
  if (tag === "sign_true") {
    return (
      <Tag color="green">
        Подписано руководителем
        <Tooltip
          title="Скачать файл подписи руководителя"
          color="white"
          overlayInnerStyle={{ color: "#282828", fontSize: "12px" }}
        >
          <DownloadOutlined
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={onClickDownload}
          />
        </Tooltip>
        <Tooltip
          title="Проверить информацию о подписи"
          color="white"
          overlayInnerStyle={{
            color: "#282828",
            fontSize: "12px",
          }}
        >
          <SignatureOutlined
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={onClickSignInfo}
          />
        </Tooltip>
      </Tag>
    );
  } else if (tag === "sign_false") {
    return <Tag color="red">Без подписи руководителя</Tag>;
  }

  return <Tag>Документ не загружен</Tag>;
};
